//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
import { ref, onMounted } from '@vue/composition-api'
import {
  useRouter,
  isAndroid,
  isIOS,
  openTab,
  defaultDownloadAppByOS,
} from '@core/utils'
import { avatarText } from '@core/utils/filter'
import { useUtils } from '@core/libs/i18n'
import themeConfig from '@themeConfig'
import { asyncLoading } from 'vuejs-loading-plugin'
import { mdiClose, mdiAccountGroup } from '@mdi/js'
import { getVideoCircle } from '@api'

export default {
  setup() {
    const { route } = useRouter()
    const { t } = useUtils()

    const deepLinkGroup = ref('fanaty://circle?circle_id=')

    const circle = ref({
      circle_id: null,
      circle_logo: null,
      circle_name: null,
    })
    const circleId = ref(null)
    const refCode = ref(null)
    const hasException = ref(false)
    const invalidInvitation = ref(false)
    const timerWatch = ref(null)
    const isOpen = ref(false)

    const fiveSecondPromise = () => new Promise(resolve => {
      setTimeout(resolve, 5000)
    })

    const onWatch = () => {
      isOpen.value = true
      if (isAndroid() || isIOS()) {
        // const timestamp = new Date().getTime()
        // if (isIOS()) openTab(`${deepLinkGroup.value}${circleId.value}?t=${timestamp}`)
        // else window.location = `${deepLinkGroup.value}${circleId.value}?t=${timestamp}`
        if (isIOS()) openTab(`${deepLinkGroup.value}${circleId.value}`)
        else window.location = `${deepLinkGroup.value}${circleId.value}`

        asyncLoading(fiveSecondPromise()).then().catch()
        clearTimeout(timerWatch.value)
        timerWatch.value = setTimeout(() => {
          isOpen.value = true

          setTimeout(() => {
            isOpen.value = false
          }, 10000)
        }, 5000)
      } else openTab('https://www.fanaty.com')
    }

    onMounted(async () => {
      refCode.value = route.value.params.code
      const resp = await getVideoCircle(refCode.value)
      circle.value = resp.data
      circleId.value = resp.data.circle_id

      if (!resp.ok) {
        if (resp.message.code === 'CL002') hasException.value = true
        if (resp.message.code === 'CL003') invalidInvitation.value = true
      }
    })

    return {
      circle,
      circleId,
      refCode,
      hasException,
      invalidInvitation,
      isOpen,

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
      appLogoTitle: themeConfig.app.logoTitle,

      openTab,
      defaultDownloadAppByOS,
      onWatch,
      avatarText,

      t,

      icons: {
        mdiClose,
        mdiAccountGroup,
      },
    }
  },
}
